import React from "react";
import styled from "styled-components";
import tokens from "@company-mrv/mrv-design-system/tokens";
import typography from "@company-mrv/mrv-design-system/typography";
import InputMask from "react-input-mask";
import { Error } from "@company-mrv/mrv-design-system/icons";

export const InputStyles = `
  width: 100%;
  font-family: Averta Std;
  padding: 10px 16px;
  box-sizing: border-box;
  border-radius: 8px;
  border: 2px solid ${tokens.colorNeutralLight};
  font-size: 16px;
  line-height: 28px;
  color: ${tokens.colorNeutralXdark};
  transition: border 0.2s ease;
  margin: 0 !important;
  &::placeholder {
    color: ${tokens.colorNeutralMedium};
  }

  [data-whatintent='mouse'] &:hover {
    border-color: ${tokens.colorNeutralMedium};
  }

  &:focus {
    border-color: ${tokens.colorNeutralMedium};
  }
`;

const Container = styled.div`
  width: 100%;
`;

const InputContainer = styled.div`
  width: 100%;
  position: relative;
`;
const StyledInput = styled(InputMask)`
  ${InputStyles}

  ${props =>
    props.error &&
    `border-color: ${tokens.colorSupportError} !important;
      padding-right: 45px;`}
`;

export const Label = styled.label`
  ${typography.small.styles};
  line-height: 22px;
  width: 100%;
  text-align: left;
  color: ${tokens.colorNeutralXdark};
`;

const ErrorMessage = styled.div`
  font-size: 12px;
  line-height: 1.67;
  color: ${tokens.colorSupportError};
  min-height: 20px;
`;

const ErroIcon = styled(Error)`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
`;

const Input = props => {
  const { label, error, onChangeValue, onFocus, ...remainingProps } = props;

  const handleFocus = event => {
    if (onFocus) {
      onFocus(event);
    }
  };

  const handleChange = e => onChangeValue && onChangeValue(e.target.value);

  return (
    <Container>
      {label?.length > 0 && <Label>{label}</Label>}
      <InputContainer>
        <StyledInput
          {...remainingProps}
          onChange={handleChange}
          error={error}
          onFocus={handleFocus}
        />
        {error && (
          <ErroIcon
            a11yTitle="Error"
            color={tokens.colorSupportError}
            size="24px"
          />
        )}
      </InputContainer>
      <ErrorMessage>{error ?? ""}</ErrorMessage>
    </Container>
  );
};

export default Input;
